//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* jshint jquery: true */

(function() {
  angular.module('curalate')
        /*
         * toggle is a common component that exposes a styled button group of options that invokes a callback function when a new value is selected.
         *
         * @attr toggleSelect       The callback function within the parent scope that should be invoked when a new toggle is selected.
         * @attr default            (Optional) The default value among toggle options. If none provided, defaults to first options.
         * @attr disabled           (Optional) The value to determine if the entire toggle should be disabled. Note that toggles can also
                                    be disabled on the individual level.
         * @attr trackingCategory   (Optional) The string used for any TrackingService calls.
         * @attr watchedOption      (Optional) A value to watch that should trigger a newly selected option.
         */
        .directive('toggle', () => {
          let trackingCategory;

          return {
            restrict: 'E',
            transclude: true,
            scope: {
              toggleSelect: '&',
              default: '=',
              disabled: '=',
              watchedOption: '=',
            },
            replace: false,
            template: require('@partials/toggle.html'),
            controller: ['$scope', '$rootScope', 'TrackingService', function($scope, $rootScope, TrackingService) {
              $scope.selectOption = function(option) {
                if ($scope.selectedOption && $scope.selectedOption.value === option.value) {
                  return; // The user is attempting to select the option that's already selected. IGNORE.
                }

                        // Change page appearance
                $scope.selectedOption = option;

                        // Invoke callback function in parent scope
                $scope.toggleSelect({ value: option.value });

                        // If caller has passed a tracking category then let's use it to log an event to GA
                if (trackingCategory) {
                  TrackingService.recordEvent(trackingCategory, TrackingService.ACTION_SELECT_TOGGLE, option.value);
                }
              };

              if ($scope.watchedOption) {
                $scope.$watch('watchedOption', (value) => {
                  if (value) {
                    if ($scope.selectedOption && $scope.selectedOption.value === value) {
                      return; // The user is attempting to select the option that's already selected. IGNORE.
                    }
                    $scope.selectedOption = { value };
                  }
                });
              }

              this.registerOption = function(option) {
                        // Mark the default if one is given
                if (
                            (!$scope.default && !$scope.selectedOption) || // automatically set to first option
                            ($scope.default === option.value) // 'default' value found
                        ) {
                  $scope.selectedOption = option;
                }
                $scope.options.push(option);
              };

              this.updateOption = function(updatedOption) {
                const optionToUpdateIndex = _($scope.options).indexOf(currentOption => currentOption.value === updatedOption.value);

                if (optionToUpdateIndex !== -1) {
                  $scope.options[optionToUpdateIndex] = updatedOption;
                }
              };
            }],
            link: {
              pre(scope, element, attrs) {
                trackingCategory = attrs.trackingCategory;
                scope.options = [];
              },
            },
          };
        });
})();
